module.exports = __webpack_public_path__ + "media/images/icons/filled/twitter-square-3bddb6b7b5fea5a1b129abe209e4ad16.svg";